module.exports = __webpack_public_path__ + "img/cropped-mariola-grobelska-XlmMpqFMBp0-unsplash-compressed-mobile.afca851b.webp";